export default [
  {
    path: '/perfils',
    name: 'perfils',
    component: () => import('@/views/app/perfilAcesso/perfilAcesso-list/PerfilAcessoList.vue'),
    meta: {
      pageTitle: 'Perfil Acesso',
      action: 'read',
      resource: 'PerfilAcesso',
    },
  },
  {
    path: '/apps/perfilAcesso/edit/:id',
    name: 'apps-perfil-edit',
    component: () => import('@/views/app/perfilAcesso/perfilAcesso-edit/PerfilAcessoEdit.vue'),
    meta: {
      pageTitle: 'Editar Perfil',
      action: 'read',
      resource: 'PerfilAcesso',
    },
  },
];
